export default __webpack_public_path__ + "static/media/puolesta-asiointi-darkblue.4060c629.svg";